import StoreBuilder from '../store-builder';

const builder = new StoreBuilder('navigation');
builder.addStatePart('pending', false);

builder.setActions({
  start ({ commit }) {
    commit('SET_PENDING', true);
  },

  end ({ commit }) {
    commit('SET_PENDING', false);
  }
});

export default builder.build();
